import dayjs from "dayjs";
var getTripType = function (itineraries) {
    if (itineraries.length === 1) {
        return 'O';
    }
    else if (itineraries.length === 2 &&
        getItineraryAirportCode(itineraries[0], 'from') === getItineraryAirportCode(itineraries[1], 'to') &&
        getItineraryAirportCode(itineraries[0], 'to') === getItineraryAirportCode(itineraries[1], 'from')) {
        return 'R';
    }
    return 'M';
};
var isCompanionPricing = function (_a) {
    var _b, _c;
    var tripType = _a.tripType, passengerAndCabinClass = _a.passengerAndCabinClass, itineraries = _a.itineraries, companionPricing = _a.companionPricing;
    if (tripType === 'M' || !passengerAndCabinClass || !itineraries || !companionPricing) {
        return false;
    }
    // Loop over companion pricing
    for (var i = 0; i < companionPricing.length; i++) {
        var companionPrice = companionPricing[i];
        var currentDate = dayjs();
        var saleStartDate = dayjs(companionPrice.saleStartDate);
        var saleEndDate = dayjs(companionPrice.saleEndDate);
        if ((!currentDate.isAfter(saleStartDate) && !currentDate.isSame(saleStartDate)) || !currentDate.isBefore(saleEndDate) && !currentDate.isSame(saleEndDate)) {
            continue;
        }
        // Check if the trip type matches
        if (companionPrice.tripType === 'both' || companionPrice.tripType.toUpperCase().charAt(0) === tripType) {
            // Check if the passenger counts match
            if (companionPrice.adults === passengerAndCabinClass.adults && companionPrice.youth === passengerAndCabinClass.youth && companionPrice.child === passengerAndCabinClass.child && companionPrice.infant === passengerAndCabinClass.infant) {
                if (companionPrice.from === ((_b = itineraries[0].fromAirport) === null || _b === void 0 ? void 0 : _b.locIATA) && companionPrice.to === ((_c = itineraries[0].toAirport) === null || _c === void 0 ? void 0 : _c.locIATA)) {
                    // Check if the departure date is within the range
                    var travelStartDate = dayjs(companionPrice.travelStartDate);
                    var travelEndDate = dayjs(companionPrice.travelEndDate);
                    var departureDate = dayjs(itineraries[0].departureDate);
                    if (departureDate.isAfter(travelStartDate) && departureDate.isBefore(travelEndDate)) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
};
var getPassengerParams = function (passengerAndCabinClass, companionPricing) {
    var travelerInfo = [];
    if (passengerAndCabinClass) {
        var adults = 0;
        var child = 0;
        var youth = 0;
        var infant = 0;
        for (var i = 1; i < 10; i++) {
            if (adults < passengerAndCabinClass.adults) {
                var code = 'ADT';
                if (companionPricing && i === 1) {
                    code = 'CMA';
                }
                else if (companionPricing && i === 2) {
                    code = 'CMP';
                }
                travelerInfo.push({
                    passengerTypeCode: code,
                });
                adults++;
            }
            else if (child < passengerAndCabinClass.child) {
                travelerInfo.push({
                    passengerTypeCode: 'CHD',
                });
                child++;
            }
            else if (youth < passengerAndCabinClass.youth) {
                travelerInfo.push({
                    passengerTypeCode: 'YTH',
                });
                youth++;
            }
            else if (infant < passengerAndCabinClass.infant) {
                travelerInfo.push({
                    passengerTypeCode: 'INF',
                });
                infant++;
            }
        }
    }
    return travelerInfo;
};
var getItineraryAirportCode = function (itinerary, fromOrTo) {
    var _a, _b, _c, _d;
    if (fromOrTo === void 0) { fromOrTo = 'from'; }
    switch (fromOrTo) {
        case 'to':
            return (_a = itinerary.toAirportCode) !== null && _a !== void 0 ? _a : (_b = itinerary.toAirport) === null || _b === void 0 ? void 0 : _b.locIATA;
        case 'from':
        default:
            return (_c = itinerary.fromAirportCode) !== null && _c !== void 0 ? _c : (_d = itinerary.fromAirport) === null || _d === void 0 ? void 0 : _d.locIATA;
    }
};
var getItineraryParams = function (itineraries) {
    var itinerariesRefx = [];
    if (itineraries) {
        var filteredItineraries = itineraries.filter(function (itinerary) { return !itinerary.ignore; });
        filteredItineraries.forEach(function (itinerary, i) {
            var fromAirportCode = getItineraryAirportCode(itinerary, 'from');
            var toAirportCode = getItineraryAirportCode(itinerary, 'to');
            if (fromAirportCode && toAirportCode && itinerary.departureDate) {
                itinerariesRefx.push({
                    originLocationCode: fromAirportCode,
                    destinationLocationCode: toAirportCode,
                    departureDateTime: dayjs(itinerary.departureDate).endOf('day').format('YYYY-MM-DD'),
                });
            }
        });
    }
    return itinerariesRefx;
};
export default function createAmadeusRefxPostBody(_a) {
    var amadeusFareFamilies = _a.amadeusFareFamilies, itineraries = _a.itineraries, promoCode = _a.promoCode, passengerAndCabinClass = _a.passengerAndCabinClass, companionPricing = _a.companionPricing, preferences = _a.preferences;
    var body = {};
    var tripType = getTripType(itineraries !== null && itineraries !== void 0 ? itineraries : []);
    var isCompanionPricingVar = isCompanionPricing({
        tripType: tripType,
        passengerAndCabinClass: passengerAndCabinClass,
        itineraries: itineraries,
        companionPricing: companionPricing,
    });
    var itineraryParams = getItineraryParams(itineraries);
    var passengerParams = getPassengerParams(passengerAndCabinClass, isCompanionPricingVar);
    body.itineraries = itineraryParams;
    body.travelers = passengerParams;
    body.commercialFareFamilies = ['CFFECOBIZ'];
    if ((passengerAndCabinClass === null || passengerAndCabinClass === void 0 ? void 0 : passengerAndCabinClass.cabin) === 'business') {
        body.commercialFareFamilies = ['CFFBIZ'];
    }
    if (promoCode) {
        body.promotion = {
            code: promoCode,
        };
        body.airlineCode = 'KQ';
    }
    var country = preferences === null || preferences === void 0 ? void 0 : preferences.country.value;
    var portalFacts = [
        {
            key: 'countryCode',
            value: (country === 'GLOBAL' || !country) ? 'ER' : country
        }
    ];
    return {
        search: JSON.stringify(body),
        portalFacts: JSON.stringify(portalFacts),
    };
}
